
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gL8fPfgeL80jvwG3TvlG6rFOuDbe8bmLW1kJgjxVVSBMMeta } from "/codebuild/output/src983737490/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as index7jpQ02RH5YT87rsdEBoJDmcpiefEr24DSuQ0KCmaBI4Meta } from "/codebuild/output/src983737490/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as search60nwisN9xHe6kfXT4hgjMdTyugYup_45Wmtrfj0GUbejkMeta } from "/codebuild/output/src983737490/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexX_45rWOxVeOVD0yh5UCUJfYQ5N7ZYpGUB6LF96IhFTZgIMeta } from "/codebuild/output/src983737490/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93ChjGcEyPx8smGZyYhjPQfI1KDVZbzzppJJ91uGtlFKQMeta } from "/codebuild/output/src983737490/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexkjBeDcmYxpD2bbAkeCcY7ZM_455oNp1Fkg0nRhknh_EhoMeta } from "/codebuild/output/src983737490/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93jlNbTV7G_45qiy66H9nXFTMx2c3_458VLYTExyUitv5uVw4Meta } from "/codebuild/output/src983737490/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexjkfQ7UchInOHUmrTWFp9bu5_9U8MTXwb4mU0m4tjbrsMeta } from "/codebuild/output/src983737490/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93_45LgdqNyYHATIcVXl0j4Tg7mXRNY5by0xFINy0LQPp1EMeta } from "/codebuild/output/src983737490/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexOdpX5SspIv2run1B6uv_45s6thORiI2Yz4vqgoENjXubcMeta } from "/codebuild/output/src983737490/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexPrfhiAv_45PXmDFGM03EPcS0BP3ewKjMe9cKg7syndb0AMeta } from "/codebuild/output/src983737490/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src983737490/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src983737490/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src983737490/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src983737490/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src983737490/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexkjBeDcmYxpD2bbAkeCcY7ZM_455oNp1Fkg0nRhknh_EhoMeta || {},
    component: () => import("/codebuild/output/src983737490/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src983737490/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexjkfQ7UchInOHUmrTWFp9bu5_9U8MTXwb4mU0m4tjbrsMeta || {},
    component: () => import("/codebuild/output/src983737490/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src983737490/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexOdpX5SspIv2run1B6uv_45s6thORiI2Yz4vqgoENjXubcMeta || {},
    component: () => import("/codebuild/output/src983737490/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexPrfhiAv_45PXmDFGM03EPcS0BP3ewKjMe9cKg7syndb0AMeta || {},
    component: () => import("/codebuild/output/src983737490/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]